import { OfferDto } from "@intelligems/ig-types";

export function getDiscountThresholdByOffer(offer: OfferDto) {
  const tiers = offer?.tiers ?? [];
  const lastTier = tiers[tiers.length - 1];
  return lastTier?.minimumUnits;
}
